export const personalHomeRoute = {
    patterns: {
        personalHome: '/me',
    },
} as const;
